import { useAtom } from 'jotai';
import { useEffect, useState } from 'react';

import { useInboxService } from '@/src/infrastructure/Protocol/Inbox/useInboxService';

import { atomHasInbox } from '@/modules/InboxModule/atoms/inboxAtom';

export const useInboxContractStatus = () => {
  const [isLoadingCheckInbox, setIsLoadingCheckInbox] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const [hasInbox, setHasInbox] = useAtom(atomHasInbox);

  const inboxService = useInboxService();

  useEffect(() => {
    const checkInbox = async () => {
      try {
        setIsLoadingCheckInbox(true);
        setError(null);

        const serviceMethod = inboxService.getInboxContractStatus.bind(inboxService);

        const hasInbox = await serviceMethod();
        setHasInbox(hasInbox);
      } catch (err) {
        setError(err instanceof Error ? err : new Error('Error checking inbox status'));
        setHasInbox(false);
      } finally {
        setIsLoadingCheckInbox(false);
      }
    };

    void checkInbox();
  }, [inboxService, setHasInbox]);

  return {
    hasInbox,
    isLoadingCheckInbox: isLoadingCheckInbox,
    error,
  };
};
